export default __webpack_public_path__ + "static/media/GIF_1.dd561ddb.mp4";